import { Trans } from "@lingui/react";
import { i18n } from "@lingui/core";
import React from 'react';
import { pathOr } from 'ramda';
import styled from 'styled-components';
import FuzzySearch from 'fuzzy-search';
import { Autocomplete, Button } from '@prezi/bento';
import HighlightOption from '../../../molecules/dumb/HighlightOption';
import { TOOLTIP_ROOT } from '../../../const';
import Email from '../../../../models/Email';
const FormWrapper = styled.div.withConfig({
  displayName: "AddCollaborators__FormWrapper",
  componentId: "keu2qo-0"
})(["display:flex;flex-wrap:wrap;& > *{margin-inline-end:10px;}"]);
const NameEmailWrap = styled.div.withConfig({
  displayName: "AddCollaborators__NameEmailWrap",
  componentId: "keu2qo-1"
})(["flex:1;padding-bottom:;"]);
const AddCollaborators = ({
  contacts,
  collaborators,
  onSave,
  folderUuid
}) => {
  const autoCompleteHandle = React.useRef(null);
  const [searcher, setSearcher] = React.useState(null);
  const [email, setEmail] = React.useState(undefined);
  const collaboratorEmails = collaborators.asList().map(collaborator => collaborator.email);
  const contactList = contacts.exclude(...collaboratorEmails).asList();
  React.useEffect(() => {
    if (contactList.length) {
      const newSearcher = new FuzzySearch(contactList, ['name', 'email'], {
        caseSensitive: false,
        sort: true
      });
      setSearcher(newSearcher);
    }
  }, [contactList.length]);
  React.useEffect(() => {
    var _autoCompleteHandle$c;
    (_autoCompleteHandle$c = autoCompleteHandle.current) === null || _autoCompleteHandle$c === void 0 ? void 0 : _autoCompleteHandle$c.clearSelectedItem();
  }, [collaboratorEmails.length]);
  return React.createElement(FormWrapper, null, React.createElement(NameEmailWrap, null, React.createElement(Autocomplete, {
    value: email === null || email === void 0 ? void 0 : email.toString(),
    options: contactList.map(pathOr('', ['email'])),
    placeholder: i18n._("Name or e-mail address"),
    portalRoot: TOOLTIP_ROOT,
    onChange: value => {
      setEmail(Email.fromString(value));
    },
    matchFunction: (inputValue = '') => {
      setEmail(Email.fromString(inputValue));
      if (searcher) {
        return searcher.search(inputValue).map(pathOr('', ['email']));
      }
      return [];
    },
    dummyDropdownItemValue: 'prezi@example.com',
    OptionComponent: ({
      value = '',
      currentInput
    }) => React.createElement(HighlightOption, {
      currentInput: currentInput,
      name: pathOr('', ['byId', value, 'name'], contacts),
      email: Email.unsafeFromString(value)
    }),
    "data-lookup": "share-dialog-add-collaborator-input",
    ref: autoCompleteHandle
  })), React.createElement("div", null, React.createElement(Button, {
    size: "medium",
    variant: "primary",
    disabled: !email,
    onClick: () => email && onSave(email, folderUuid),
    "data-lookup": "share-dialog-add-collaborator-button"
  }, React.createElement(Trans, {
    id: "Add"
  }))));
};
export default AddCollaborators;